import { msg } from '@lingui/core/macro';
import { APP_PATHS } from 'app-shared/constants';
import { IconCalendar, IconInbox } from 'app-ui/icon';

import { type NavigationItem } from '@/navigation/types/NavigationItem';

// The main pages, in drawer order. To add a page: add its path to APP_PATHS,
// its route to AppRouter, and an entry here. The drawer, the command menu and
// the go-to shortcuts all read this list.
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'my-planning',
    label: msg`My planning`,
    Icon: IconCalendar,
    path: APP_PATHS.myPlanning,
    goToHotkey: 'g m',
  },
  {
    id: 'planning-board',
    label: msg`Planning`,
    Icon: IconCalendar,
    path: APP_PATHS.planning,
    goToHotkey: 'g h',
  },
  {
    id: 'backlog',
    label: msg`To plan`,
    Icon: IconInbox,
    path: APP_PATHS.backlog,
    goToHotkey: 'g b',
  },
  {
    id: 'absences',
    label: msg`Absences`,
    Icon: IconCalendar,
    path: APP_PATHS.absences,
    goToHotkey: 'g a',
  },
];
